import { Directive, ElementRef, Renderer2, Input, OnChanges, SimpleChanges } from "@angular/core";

@Directive({
	selector: "[appHighlight]",
	standalone: false
})
export class HighlightDirective implements OnChanges {
	@Input() appHighlight: string = "";
	@Input() baseText: string = "";

	constructor(
		private el: ElementRef,
		private renderer: Renderer2
	) {}

	public ngOnChanges(changes: SimpleChanges): void {
		if (changes["appHighlight"] || changes["baseText"]) {
			this.highlightText();
		}
	}

	private highlightText(): void {
		if (!this.appHighlight || !this.baseText) {
			this.renderer.setProperty(this.el.nativeElement, "innerHTML", this.baseText);
			return;
		}

		const re = new RegExp(`(${this.escapeRegExp(this.appHighlight)})`, "gi");
		const newHtml = this.baseText.replace(re, `<span style="font-weight: 700;">$1</span>`);

		this.renderer.setProperty(this.el.nativeElement, "innerHTML", newHtml);
	}

	private escapeRegExp(text: string): string {
		return text.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
	}
}
